<template>
    <div v-if="!accept" class="p-5">
      Bạn chưa được phép xem trang này!
    </div>
    <div v-else>
        <generic-form-view
            rootPath="/v2/products"
            :forms="forms"
            :columns="columns"
            :table_name="table_name"
            @onSubmitted="onSubmit"
            @onShowTool="showTool"
            >

        </generic-form-view>

        <div v-if="isShowTool" class="toolbar">
          <b-button variant="primary" @click="gotoPosting" class="ml-2">Đăng tin</b-button>
          <b-button variant="success" @click="gotoView" class="ml-2">Xem Chi tiết</b-button>
          <b-button variant="info" @click="generateNewProductCode" class="ml-2">Sinh mã sp mới</b-button>
        </div>
        
    </div>

</template>

<script>
import TableMeta from '@/models/ProductTableMeta'
import GenericFormView from '@/views/base/GenericFormView'
import ProductService from '@/services/productService'

export default {
  name: 'ProductEntryForm',
  components: {
    'generic-form-view': GenericFormView
    },
  data () {
    return {
        forms: TableMeta.input_view.forms,
        columns: TableMeta.columns,
        table_name: TableMeta.table_name,
        isShowTool: false,
    }
  },
  computed: {
    accept() {
      // if (this.$route.params.id != 'new') {
      //   if (this.$store.getters.role == 'ctv') {
      //     return false;
      //   }
      // }
      return true;
    }
  },
  methods: {
    onSubmit (id, isNewRecord) {
      if(isNewRecord) {
        this.$router.replace({path: `/v2/products/${id}/view`});
        
      } else {
        this.isShowTool = true;
      }
    },

    showTool (isNeed) {
      this.isShowTool = isNeed;
    },

    gotoPosting () {
      const id = this.$route.params.id;
      console.log('id: ' + id);
      this.$router.push({path: `/v2/products/${id}/posting`});
    },

    gotoView () {
      const id = this.$route.params.id;
      console.log('id: ' + id);
      this.$router.push({path: `/v2/products/${id}/view`});
    },

    async generateNewProductCode () {
      var id = this.$route.params.id;

      var service = new ProductService();
      var productDetail = await service.getDetail(id);
      console.log(productDetail);

      var new_product_code = await service.generateNewProductCode(productDetail);

      var answer = confirm('Mã sp sẽ được đổi từ ' + productDetail.code +' sang mã mới ' + new_product_code + '. Bạn có muốn cập nhật ko?');
      console.log(answer);
      if(answer) {

        try {
          await service.updateProductColumn(productDetail.id, 'code', new_product_code, 'text');
        }
        catch (err) {
          alert(err);
        }
      }
    },
  },
  mounted () {

  }
}
</script>

<style scoped> 
.toolbar {
  margin: 20px;
  float: right;
}
</style>